import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/refresh-cw-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M2 12C2 6.47715 6.47715 2 12 2C14.7624 2 17.2645 3.12166 19.0732 4.93164C19.7128 5.5716 20.3982 6.3619 21 7.09375V4C21 3.44772 21.4477 3 22 3C22.5523 3 23 3.44772 23 4V10C23 10.5523 22.5523 11 22 11H16C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9H19.9678C19.2756 8.13143 18.4167 7.10277 17.6592 6.34473C16.2102 4.89477 14.2104 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C15.6457 20 18.7244 17.5604 19.6875 14.2227C19.8407 13.6921 20.3952 13.386 20.9258 13.5391C21.4563 13.6923 21.7625 14.2468 21.6094 14.7773C20.4058 18.9482 16.5605 22 12 22C6.47715 22 2 17.5228 2 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as RefreshCw01Icon };
